import React from "react"
import "./GeneratorModeToggle.style.scss"

interface GeneratorModeToggleProps {
  mode: "manual" | "templates"
  onManual: () => void
  onTemplates: () => void
  anchorId?: string
}

const GeneratorModeToggle = ({
  mode,
  onManual,
  onTemplates,
  anchorId,
}: GeneratorModeToggleProps) => (
  <div className="generator-mode-toggle" id={anchorId}>
    <button
      type="button"
      className={mode === "manual" ? "is-active" : undefined}
      onClick={onManual}
    >
      Manual Config
    </button>
    <button
      type="button"
      className={mode === "templates" ? "is-active" : undefined}
      onClick={onTemplates}
    >
      Admin Templates
    </button>
  </div>
)

export default GeneratorModeToggle
